import moment from "moment/moment";

const getFarthestActiveLicenseExpirationData = (licenses) => {
  if (licenses.length === 0) {
    return {
      active: false,
      farthestExpirationDate: null,
      daysToExpiration: null,
      hoursToExpiration: null,
      reason: "no_licenses_available",
    };
  }

  const activeLicenses = licenses.filter((license) => license.is_active);

  if (activeLicenses.length === 0) {
    return {
      active: false,
      farthestExpirationDate: null,
      daysToExpiration: null,
      hoursToExpiration: null,
      reason: "all_licenses_expired",
    };
  }

  const farthestExpirationLicense = activeLicenses
    .map((license) => moment(license.date_ends))
    .sort((a, b) => b.diff(a))[0];

  const daysToExpiration = farthestExpirationLicense
    .startOf("day")
    .diff(moment().startOf("day"), "days");
  const hoursToExpiration = farthestExpirationLicense
    .startOf("hour")
    .diff(moment().startOf("hour"), "hours");

  return {
    active: daysToExpiration >= 0,
    farthestExpirationDate: farthestExpirationLicense.toISOString(),
    daysToExpiration,
    hoursToExpiration,
    reason: "active_license",
  };
};

const getFarthestActiveTrialLicenseExpirationDate = (licenses = []) => {
  const pocLicenses = licenses.filter(({ type }) => type === "school_poc");
  if (pocLicenses.length > 0) {
    return {
      ...getFarthestActiveLicenseExpirationData(pocLicenses),
      isSchoolTrial: true,
    };
  }

  return {
    ...getFarthestActiveLicenseExpirationData(
      licenses.filter(
        ({ type }) => type === "campaign" || type === "campaign-extension",
      ),
    ),
    isSchoolTrial: false,
  };
};

export default getFarthestActiveTrialLicenseExpirationDate;
